import { useState, useCallback } from 'react';
import { TEST_USERS, MANAGER_INFO } from '@/mocks/auth';

export interface AuthUser {
  id: string;
  name: string;
  login: string;
  role: string;
  email: string;
}

export interface ManagerInfo {
  name: string;
  telegram: string;
  email: string;
  avatar: string | null;
}

const AUTH_KEY = 'portal_auth_user';
const MANAGER_KEY = 'portal_manager';

export function getStoredUser(): AuthUser | null {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    return raw ? (JSON.parse(raw) as AuthUser) : null;
  } catch {
    return null;
  }
}

export function getStoredManager(): ManagerInfo | null {
  try {
    const raw = localStorage.getItem(MANAGER_KEY);
    return raw ? (JSON.parse(raw) as ManagerInfo) : null;
  } catch {
    return null;
  }
}

export function useAuth() {
  const [user, setUser] = useState<AuthUser | null>(getStoredUser);

  const login = useCallback(async (loginVal: string, password: string): Promise<boolean> => {
    const found = TEST_USERS.find(
      (u) => u.login === loginVal.trim() && u.password === password,
    );
    if (!found) return false;

    const authUser: AuthUser = {
      id: found.id,
      name: found.name,
      login: found.login,
      role: found.role,
      email: found.email,
    };
    localStorage.setItem(AUTH_KEY, JSON.stringify(authUser));

    const manager: ManagerInfo = {
      name: MANAGER_INFO.name,
      telegram: MANAGER_INFO.telegram,
      email: MANAGER_INFO.email,
      avatar: MANAGER_INFO.avatar,
    };
    localStorage.setItem(MANAGER_KEY, JSON.stringify(manager));

    setUser(authUser);
    return true;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem(MANAGER_KEY);
    setUser(null);
  }, []);

  return { user, login, logout };
}
